import React from "react";
import "./App.css";
import Editor from "./components/Editor";

const App: React.FC = () => {
  return (
    <div className="App">
      <Editor />
    </div>
  );
};

export default App;
